




















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Means } from './types';

@Component({})
export default class MeansMainContent extends Vue {
  @Prop({ default: {} }) means!: Means;
}
